<template>
    <v-container fluid grid-list-sm>
        <v-layout>
            <v-flex md12>
                <v-card>
                    <v-card-title>
                        <div>
                            <h3 class="headline mb-0">Grupos Disponibles</h3>
                        </div>
                    </v-card-title>
                    <v-card-text v-if="!fueraDeTiempo">
                        <v-data-table
                                :headers="headers"
                                :items="grupos"
                                hide-actions
                                v-if="$mq !== 'sm'"
                        >
                            <template slot="items" slot-scope="props">
                                <td>
                                    <strong>{{props.item.nombre}}</strong><br>
                                    {{props.item.clave}} <br>
                                    {{ props.item.docente}}
                                </td>
                                <td>{{props.item.grupo}}</td>
                                <td>{{props.item.creditos}}</td>
                                <td>{{formatoHorario(props.item.horario[2])}}</td>
                                <td>{{formatoHorario(props.item.horario[3])}}</td>
                                <td>{{formatoHorario(props.item.horario[4])}}</td>
                                <td>{{formatoHorario(props.item.horario[5])}}</td>
                                <td>{{formatoHorario(props.item.horario[6])}}</td>
                                <td>{{formatoHorario(props.item.horario[7])}}</td>
                                <td>{{formatoHorario(props.item.horario[1])}}</td>
                            </template>
                        </v-data-table>
                        <v-data-iterator
                                :items="grupos"
                                :rows-per-page-items="[10]"
                                content-tag="v-layout"
                                row
                                wrap
                                v-else-if="$mq === 'sm'"
                        >
                            <v-flex
                                    slot="item"
                                    slot-scope="props"
                                    xs12
                                    sm6
                                    md4
                                    lg3
                            >
                                <v-card>
                                    <v-card-title primary-title>
                                        <div>
                                            <h4>{{ props.item.nombre }}</h4>
                                            <div>{{ props.item.clave}}</div>
                                            <div>{{ props.item.docente}}</div>
                                        </div>
                                    </v-card-title>
                                    <v-divider></v-divider>
                                    <v-list dense>
                                        <v-list-tile>
                                            <v-list-tile-content>Grupo:</v-list-tile-content>
                                            <v-list-tile-content class="align-end">{{ props.item.grupo }}</v-list-tile-content>
                                        </v-list-tile>
                                        <v-list-tile>
                                            <v-list-tile-content>Creditos:</v-list-tile-content>
                                            <v-list-tile-content class="align-end">{{ props.item.creditos }}</v-list-tile-content>
                                        </v-list-tile>
                                        <v-list-tile v-if="props.item.horario[2]">
                                            <v-list-tile-content>Lunes:</v-list-tile-content>
                                            <v-list-tile-content class="align-end">{{ formatoHorario(props.item.horario[2]) }}</v-list-tile-content>
                                        </v-list-tile>
                                        <v-list-tile v-if="props.item.horario[3]">
                                            <v-list-tile-content>Martes:</v-list-tile-content>
                                            <v-list-tile-content class="align-end">{{ formatoHorario(props.item.horario[3]) }}</v-list-tile-content>
                                        </v-list-tile>
                                        <v-list-tile v-if="props.item.horario[4]">
                                            <v-list-tile-content>Miércoles:</v-list-tile-content>
                                            <v-list-tile-content class="align-end">{{ formatoHorario(props.item.horario[4]) }}</v-list-tile-content>
                                        </v-list-tile>
                                        <v-list-tile v-if="props.item.horario[5]">
                                            <v-list-tile-content>Jueves:</v-list-tile-content>
                                            <v-list-tile-content class="align-end">{{ formatoHorario(props.item.horario[5]) }}</v-list-tile-content>
                                        </v-list-tile>
                                        <v-list-tile v-if="props.item.horario[6]">
                                            <v-list-tile-content>Viernes:</v-list-tile-content>
                                            <v-list-tile-content class="align-end">{{ formatoHorario(props.item.horario[6]) }}</v-list-tile-content>
                                        </v-list-tile>
                                        <v-list-tile v-if="props.item.horario[7]">
                                            <v-list-tile-content>Sábado:</v-list-tile-content>
                                            <v-list-tile-content class="align-end">{{ formatoHorario(props.item.horario[7]) }}</v-list-tile-content>
                                        </v-list-tile>
                                        <v-list-tile v-if="props.item.horario[1]">
                                            <v-list-tile-content>Domingo:</v-list-tile-content>
                                            <v-list-tile-content class="align-end">{{ formatoHorario(props.item.horario[1]) }}</v-list-tile-content>
                                        </v-list-tile>
                                    </v-list>
                                </v-card>
                            </v-flex>
                        </v-data-iterator>
                    </v-card-text>
                    <v-card-text v-else>
                        El proceso de reinscripción se encuentra cerrado.
                    </v-card-text>
                </v-card>
            </v-flex>
            <v-dialog v-model="cargandoDatos" max-width="280px" persistent>
                <v-card>
                    <v-card-title>
                        <v-progress-circular :size="50" indeterminate color="primary"></v-progress-circular>
                        <v-spacer></v-spacer>
                        <span>Cargando horario de clases</span>
                    </v-card-title>
                </v-card>
            </v-dialog>
        </v-layout>
    </v-container>
</template>

<script>
  import axios from 'axios'

  export default {
    name: 'GruposDisponiblesPage',
    mounted () {
      this.getGruposDisponibles()
    },
    data: () => ({
      cargandoDatos: true,
      headers: [
        {
          text: 'Materia',
          align: 'left',
          value: 'nombre'
        },
        { text: 'Gpo', value: 'grupo' },
        { text: 'Cr', value: 'creditos' },
        { text: 'Lunes', value: 'lunes' },
        { text: 'Martes', value: 'martes' },
        { text: 'Miércoles', value: 'miercoles' },
        { text: 'Jueves', value: 'jueves' },
        { text: 'Viernes', value: 'viernes' },
        { text: 'Sábado', value: 'sabado' },
        { text: 'Domingo', value: 'domingo' }
      ],
      grupos: [],
      fueraDeTiempo: false
    }),
    methods: {
      getGruposDisponibles () {
        axios.get('alumno/grupos-disponibles?listar-grupos=1')
          .then(request => {
            this.grupos = request.data.grupos
            this.fueraDeTiempo = request.data.fueraDeTiempo
          })
          .finally(() => {
            this.cargandoDatos = false
          })
      },
      formatoHorario (item) {
        return item === '' ? '' : item.horaInicial + '-' + item.horaFinal + '/' + item.aula
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/inscripciones/GruposDisponiblesPage.vue